import React from "react"

import { SxProps, TextField as MuiTextField, TextFieldProps } from "@mui/material"
import { SystemStyleObject } from "@mui/system"

export const TextField: React.FC<TextFieldProps> = ({
  sx,
  children,
  inputProps,
  InputProps,
  ...rest
}) => {
  const { sx: inputSx, ...restProps } = inputProps || {}
  const { sx: inputWrapperSx, ...restInputProps } = InputProps || {}
  const { fieldSet: fieldSetSx, ...restInputWrapperProps } = (inputWrapperSx || {}) as SxProps & {
    fieldSet: SxProps
  }

  return (
    <MuiTextField
      inputProps={{
        sx: {
          p: "1rem 1.25rem",
          lineHeight: "1.5rem",
          fontSize: "1rem",
          height: "auto",
          ...(inputSx || {}),
        },
        ...(restProps || {}),
      }}
      InputProps={{
        sx: {
          "& fieldset": {
            borderWidth: "2px",
            ...(fieldSetSx || {}),
          } as SystemStyleObject,
          "&:hover": {
            borderWidth: "2px",
          },
          ...(restInputWrapperProps || {}),
        },
        ...(restInputProps || {}),
      }}
      sx={{
        bgcolor: "common.white",
        borderRadius: 1,
        ...(sx || {}),
      }}
      {...rest}
    >
      {children}
    </MuiTextField>
  )
}
